import { render, staticRenderFns } from "./Lv1Dil.vue?vue&type=template&id=66d9b05e"
import script from "./Lv1Dil.vue?vue&type=script&lang=js"
export * from "./Lv1Dil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports